module.exports = "/images/off_road_white.png?e2523aa2718abc04da21436bd6e9706c";